module.exports = __webpack_public_path__ + "static/media/check_24px.0d150879.svg";